import Vue from 'vue';
import Vuex from 'vuex';
import token from '@/store/modules/token';
import admin from '@/store/modules/admin';
import condomin from './store/modules/condomin';
import unidades from './store/modules/unidades';
import conceptos from './store/modules/conceptos';
import cuentas from './store/modules/cuentas';
import contables from './store/modules/contables';
import recibos from './store/modules/recibos';
import borradores from './store/modules/borradores';
import propietcondomin from './store/modules/propietcondomin';
import user from './store/modules/user';
import recurrente from './store/modules/recurrente';
import contactos from './store/modules/contactos';
import series from './store/modules/series';
import ingresos from './store/modules/ingresos';
import proveedores from './store/modules/proveedores';
// import deuda from './store/modules/deuda';
import menuBar from './store/modules/menuBar';
import egresos from './store/modules/egreso'
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    token,
    admin,
    condomin,
    unidades,
    contables,
    conceptos,
    recurrente,
    cuentas,
    recibos,
    borradores,
    propietcondomin,
    user,
    contactos,
    series,
    ingresos,
    proveedores,
    egresos,
    // deuda,
    menuBar,
  },
});
